import {useEffect, useState} from "react";
import {Checkbox, Collapse, Divider, Tag, Tooltip, Typography} from 'antd';
import ApiService from "../../core/service/api-service";
import {t} from "i18next";
import Flex from "../../core/components/Flex";
import {useUser} from "../../core/context/UserContext";

const { Panel } = Collapse;
export default function PermissionGroup({selectedPermissions = [], onChangeSelectedPermissions, disabledPermission})
{
    const [groups, setGroup] = useState([])
    const [permissions, setPermissions] = useState([])

    // Kimse kendisinde olmayan bir izni veremez (sunucu da reddeder). Kutu pasif çizilir ki yönetici
    // işaretleyip kaydetmeyi denemeden sınırı görsün. SUPER_ADMIN'i ise sunucu listeye hiç koymaz.
    const {ownsPermission} = useUser()

    const getGroups = async () => {
        const response = await ApiService.PermissionGroup.GetList()
        if(response.success)
        {
            setGroup(response.data)

            let permissions = [];
            response.data.forEach(group => {
                permissions.push(...group.permissionItems.map(p => {
                    return { ...p, groupName: group.name };
                }))
            })

            setPermissions(permissions)
        }
    }

    const getDependencies = (permission) => {
        return permissions.filter(p => permission.dependencies.includes(p.id))
    }

    // Kullanıcıda/rolde ZATEN duran ama düzenleyende olmayan izin: pasif ama işaretli kalır ve
    // seçimden düşürülmez — dokunmadığı bir izni sessizce kaldırmış olmayalım.
    const isLocked = (permission) => !ownsPermission(permission.id)

    const onCheckedPermission = (checked, permission) => {
        if(isLocked(permission))
            return

        if(checked)
        {
            onSelect([...selectedPermissions, permission.id])
        }
        else
        {
            onSelect(selectedPermissions.filter(p => p !== permission.id))
        }
    }

    const onSelect = (data) => {
        data = data.filter(x => (disabledPermission || []).findIndex(y => y === x) < 0)
        onChangeSelectedPermissions && onChangeSelectedPermissions([...new Set(data)])
    }

    useEffect(() => {
        getGroups()
    }, [])

    return (
        <>
            <Collapse>
                {
                    groups?.map(group => {
                        return (
                            <>
                                <Panel
                                    key={group.id+'g'}
                                    header={(
                                        <div>
                                            {group.name}
                                        </div>
                                    )}
                                >
                                    {
                                        group.permissions.map(p => {
                                            const locked = isLocked(p)

                                            return (
                                                <div key={p.id+'pg'} style={{marginBottom: 8, borderBottom: '1px solid #e0e0e0', paddingBottom: 8}}>
                                                    <Checkbox
                                                        id={p.id+'pg'}
                                                        onChange={(e) => {onCheckedPermission(e.target.checked, p)}}
                                                        disabled={locked || disabledPermission?.findIndex(x => x === p.id) > -1}
                                                        checked={selectedPermissions.findIndex(x => x === p.id) > -1 || disabledPermission?.findIndex(x => x === p.id) > -1}
                                                    >
                                                        <Tooltip title={locked ? t('You cannot grant a permission you do not have yourself') : t(`${p.name}_DESC`)}>
                                                            <b>{t(p.name)}</b>
                                                        </Tooltip>
                                                    </Checkbox>
                                                </div>
                                            )
                                        })
                                    }
                                </Panel>
                            </>
                        )
                    })
                }
            </Collapse>
        </>
    )
}
